import { createContext } from 'react';

export default createContext({
  trackEvent: undefined,
});
